 
<template>
  <div>
    <header class="headerCom">
      <div class="text"><span>病人管理 / 病人分组 / 查看患者 / </span><span>历史记录</span>
        <div class="head-return" @click="goReturn">返回</div>
      </div>
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input class="search-input-replay" maxlength="20" v-model="listQuery.conditionals" placeholder="请输入姓名或手机号"
            clearable autocomplete="off">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="onResetClick">重置</el-button>
          <el-button type="primary" @click="onSearchClick">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <div class="new_container" v-loading='loading' id='setHeightDom' :style="{height:height}">
      <BaseTable class="set-row-height" :data="tableData"
        :header-cell-style="{background:'#FAFAFA',color:'#333333',fontWeight:'bold'}" tooltip-effect="dark"
        :column="tableConfig" pagination :auto-scroll="true" :total="total" :page.sync="listQuery.current"
        :limit.sync="listQuery.size" @pagination="getList">
      </BaseTable>
    </div>
  </div>
</template> 
<script>
import { groupHistory } from "@/api/Patientmanagement.js";

export default {
  components: {},
  data() {
    return {
      loading: false,
      total: 100,
      listQuery: {
        conditionals: "",
        current: 1,
        size: 10
      },
      height: 500,
      tableData: [],
      tableConfig: [
        {
          label: "患者编号",
          align: "center",
          prop: "patientId",
          size: "mini"
        },
        {
          label: "微信名",
          align: "center",
          prop: "wechatName",
          size: "mini"
        },
        {
          label: "患者姓名",
          align: "center",
          prop: "patientName"
        },
        {
          label: "手机号",
          align: "center",
          prop: "phone",
          size: "mini"
        },
        {
          label: "操作记录",
          align: "center",
          prop: "changeStatus",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.changeStatus == 'out'
                  ? "移除分组"
                  : "进入分组"}
              </span>
            );
          }
        },
        {
          label: "操作时间",
          align: "center",
          prop: "createTime"
        },
        {
          label: "操作",
          align: "center",
          fixed: "right",
          width: "150px", 
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: { type: "text", size: "mini" },
                  on: {
                    click: () => {
                      // this.toEnteryDetailPage(scope);
                       this.$router.push({
                        path: "/patientmanage/detail",
                        query: {
                          patientId: scope.row.patientId
                        }
                      });
                    }
                  }
                },
                "查看"
              )
            ]);
          }
        } 
      ]
    };
  },
  mounted() {
    this.height = this.handleHeight() + "px";
    this.getList();
  },
  methods: {
    goReturn() {
      this.$router.go(-1);
    },
    onResetClick(val) {
      this.listQuery = this.$options.data().listQuery;
      this.getList();
    },
    onSearchClick() {
      this.listQuery.current = 1;
      this.getList();
    }, 
    //获取列表数据接口
    async getList() {
      let params = this.listQuery;
      let res = await groupHistory(params);
      this.loading = false;
      this.tableData = res.data && res.data.records;
      this.total = res.data.total;
    }
  }
};
</script> 
<style lang="less" scoped>
.head-return {
  width: 96px;
  height: 34px;
  background: #1a7bfc;
  text-align: center;
  line-height: 34px;
  color: #fff;
  float: right;
  cursor: pointer;
}
.new_container {
  margin: 16px 16px 0;
  padding: 24px;
  background: #fff;
  overflow: auto;
}
</style>
